export enum AssetImageType {
  Cover = "COVER",
  Frame = "FRAME",
  Highlights = "HIGHLIGHTS",
  HeroLandscape = "LANDSCAPE",
  Square = "SQUARE",
  Background = "BACKGROUND",
  Round = "ROUND",
}
